import { combineReducers } from 'redux';
import { locationDuck } from '@eb/redux-destination';

const {
    actionTypes: { UPDATE_LOCATION },
    reducersByKey: {
        suggestions,
        slug,
        placeId,
        latitude,
        longitude,
        currentPlace,
        currentPlaceParent,
        placeType,
        isWaitingForLocation,
        isUsingCurrentLocation,
        locationDenied,
        isOnline,
    },
} = locationDuck;

export const bbox = (state = null, { type, payload }) => {
    let nextState = state;

    if (type === UPDATE_LOCATION && (payload.bbox || payload.isOnline)) {
        nextState = payload.bbox;
    }

    if (type === UPDATE_LOCATION && !payload.bbox) {
        nextState = null;
    }

    return nextState;
};

export default combineReducers({
    suggestions,
    slug,
    placeId,
    latitude,
    longitude,
    bbox,
    currentPlace,
    currentPlaceParent,
    placeType,
    isWaitingForLocation,
    isUsingCurrentLocation,
    locationDenied,
    isOnline,
    topSuggestions: (state = []) => state,
});
